<header class="header">
    <div class="header-grp">
        <div class="icon" (click)="goBackToPrevPage()">
            <i class="ti ti-chevron-left"></i>
        </div>
        <div class="title">
            <h3>એકાઉન્ટ કાઢી નાખો</h3>
        </div>
    </div>
</header>
<main>
    <div class="loginWraper">
        <form [formGroup]="deleteMemberForm">
            <div class="form-group">
                <input type="text" class="form-control" placeholder="મોબાઇલ નંબર" formControlName="contact_no"  maxlength="15" />             
                <div *ngIf="submitted && f.contact_no.errors" class="error-message">
                    <small *ngIf="f.contact_no.errors?.required" class="text-danger">સંપર્ક નંબર જરૂરી છે.</small>
                </div>
                <div *ngIf="f.contact_no.errors?.pattern && f.contact_no.touched" class="error-message">
                    <small *ngIf="f.contact_no.errors?.pattern" class="text-danger">માત્ર નંબર જ માન્ય છે.</small>
                </div>
                <div *ngIf="f.contact_no.errors?.minlength && f.contact_no.touched" class="error-message">
                    <small *ngIf="f.contact_no.errors?.minlength" class="text-danger">ઓછામાં ઓછા 7 નંબર જરૂરી
                        છે.</small>
                </div>
            </div>

            <div class="form-group">
                <input type="text" class="form-control" placeholder="પાસવર્ડ" formControlName="password" />
                <div *ngIf="submitted && f.password.errors" class="error-message">
                    <small *ngIf="f.password.errors?.required" class="text-danger">પાસવર્ડ જરૂરી છે.</small>
                </div>
            </div>

            <button type="submit" class="btn-common" (click)="openDialog()">એકાઉન્ટ કાઢી નાખો</button>
        </form>
    </div>
</main>